module.exports = __webpack_public_path__ + "static/media/showmore-arrow.539e7a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showmore-arrow.svg
// module id = 1289
// module chunks = 1